import React from "react"
import PropTypes from "prop-types"
import "./SecondaryLoader.css"

const SecondaryLoader = ({ size = 40 }) => {
  return (
    <div className="secondary-loader-container">
      <div className="secondary-loader" style={{ width: size, height: size }}></div>
    </div>
  )
}

SecondaryLoader.propTypes = {
  size: PropTypes.number,
}

export default SecondaryLoader
